import { SelectOption } from "@/shared/models/ui-using/SelectOption";
import { Form } from "react-bootstrap";

interface IProps {
  placeholder: string;
  options: SelectOption[];
  value: any;
  onChange: (value: any) => void;
  isReadonly: boolean;
}

const DropDownSelect = ({ placeholder, options, value, onChange, isReadonly }: IProps) => {
  return (
    <Form.Select value={value || ""} onChange={(e) => onChange(e.target.value)} disabled={isReadonly}>
      <option value="">{placeholder}</option>
      {options.map((t) => (
        <option key={t.value} value={t.value}>
          {t.label}
        </option>
      ))}
    </Form.Select>
  );
};

export default DropDownSelect;
